import React from 'react'
import InternalServerError from 'src/routes/InternalServerError'

class ErrorBoundary extends React.Component {
    state = { hasError: false }

    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        // In production this will redirect you to the InternalServerError page. In dev we don't, so you can see the actual error.
        return {
            hasError: process.env.NODE_ENV !== 'development',
        }
    }
    componentDidCatch(error, info) {
        console.error(error)
        console.log(info)
    }

    render() {
        if (this.state.hasError) {
            return <InternalServerError />
        }

        return this.props.children
    }
}

export default ErrorBoundary
